import "phaser";
import GesturesPlugin from "phaser3-rex-plugins/plugins/gestures-plugin.js";

import { Game } from "./Game";
import { GameConstants } from "./GameConstants";
import { BootScene } from "./scenes/BootScene";
import { PreloadScene } from "./scenes/PreloadScene";
import { BattleScene } from "./scenes/battle-scene/BattleScene";
import { GameVars } from "./GameVars";
import { GameManager } from "./GameManager";
import { LobbyScene } from "./scenes/lobby-scene/LobbyScene";
import { LevelsEditorScene } from "./scenes/levels-editor-scene/LevelsEditorScene";
import { LevelFileScene } from "./scenes/levels-editor-scene/LevelFileScene";

let game: Game;

window.onload = () => {

    const gameConfig: Phaser.Types.Core.GameConfig = {

        version: GameConstants.VERSION,
        type: Phaser.AUTO,
        backgroundColor: "#000000",
        scale: {
            mode: Phaser.Scale.FIT,
            autoCenter: Phaser.Scale.CENTER_BOTH,
            parent: "content",
            width: GameConstants.GAME_WIDTH,
            height: GameConstants.GAME_HEIGHT
        },
        plugins: {
            scene: [{
                key: "rexGestures",
                plugin: GesturesPlugin,
                mapping: "rexGestures"
            },
            ]
        },
        dom: {
            createContainer: true
        },
        scene: [
            BootScene,
            PreloadScene,
            BattleScene,
            LobbyScene,
            LevelsEditorScene,
            LevelFileScene
        ]
    };

    // If compilation error here, compare Phaser definitions file of working copy (phaser.d.ts, line 48040 on 27-05-2019)
    // Also make sure to delete all *.ts files in node_modules/trailz folder
    game = new Game(gameConfig);

    window.focus();
    resize();
    window.addEventListener("resize", resize, false);
    window.addEventListener("orientationchange", checkOrientation, false);
};

function resize(): void {

    const canvas: HTMLCanvasElement = document.querySelector("canvas");
    const windowWidth: number = window.innerWidth;
    const windowHeight: number = window.innerHeight;
    const windowRatio: number = windowWidth / windowHeight;

    const gameWidth: any = game.config.width;
    const gameHeight: any = game.config.height;

    const gameRatio: number = gameWidth / gameHeight;

    if (windowRatio < gameRatio) {
        canvas.style.width = windowWidth + "px";
        canvas.style.height = (windowWidth / gameRatio) + "px";
    } else {
        canvas.style.width = (windowHeight * gameRatio) + "px";
        canvas.style.height = windowHeight + "px";
    }
}

function checkOrientation(): void {
    if (Game.currentInstance.device.os.desktop) {
        return;
    }

    GameVars.currentScene.time.addEvent({
        delay: 200, callback: () => {

            const w = window.innerWidth;
            const h = window.innerHeight;

            if (h > w) {
                document.getElementById("orientation").style.display = "block";
                document.getElementById("content").style.display = "none";
            } else {
                document.getElementById("orientation").style.display = "none";
                document.getElementById("content").style.display = "block";

                if (!GameVars.gameLoaded) {

                    GameVars.aspectRatio = window.innerWidth / window.innerHeight;
                    GameVars.contrascaleX = (GameVars.aspectRatio - (4 / 3)) * .2;

                    GameVars.scaleX = (GameConstants.GAME_WIDTH / GameConstants.GAME_HEIGHT) / (window.innerWidth / window.innerHeight);
                    GameVars.scaleY = (GameConstants.GAME_HEIGHT / GameConstants.GAME_WIDTH) / (window.innerHeight / window.innerWidth);

                    GameManager.onGameAssetsLoaded();
                    PreloadScene.currentInstance.scene.setVisible(false);
                    GameVars.gameLoaded = true;
                }
            }
        }, callbackScope: GameVars.currentScene
    });
}
